document.addEventListener("DOMContentLoaded", function() {
    const initItemSizeSwiper = (event) => {
        // get parent .item-product
        const itemProduct = event.target.closest('.item-product');
        if (!itemProduct) return;

        const itemSizes = itemProduct.querySelector('.item-sizes');
        if (!itemSizes) return;

        // Prevents multiple initializations on the same element
        if (itemSizes.classList.contains('swiper-initialized')) return;

        new Swiper(itemSizes, {
            slidesPerView: 'auto',
            centerInsufficientSlides: true,
            spaceBetween: 6,
            navigation: {
                prevEl: '.prev-size',
                nextEl: '.next-size',
            },
        });
    };

    document.addEventListener('mouseover', initItemSizeSwiper);
    document.addEventListener('touchstart', initItemSizeSwiper);

    if (document.querySelector('.tg-module')) {
        if (window.innerWidth >= 1500) {
            initTgSwiper(4);
        } else if (window.innerWidth >= 1300) {
            initTgSwiper(3);
        } else {
            initTgSwiper(2);
        }
    }

    // Modules 4 / 6 - Image + TG : one product at a time next to the image
    document.querySelectorAll('.image-tg-module .tg-module-slider.swiper').forEach(swiperEl => {
        new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 12,
            allowTouchMove: false,
            navigation: {
                nextEl: swiperEl.querySelector('.tg-module-next'),
                prevEl: swiperEl.querySelector('.tg-module-prev'),
            }
        });
    });

    document.addEventListener('mouseover', (event) => {
        if (event.target.hasAttribute('size-tooltip')) {
            const disclaimer = event.target.closest('.product-infos-form').querySelector('.disclaimer-select-size');
            const sizeSelected = event.target.closest('.product-infos-form').querySelector('input[name="prod_size"]:checked');
            if (disclaimer && !sizeSelected) {
                disclaimer.classList.add('displayed');
            }
        }
    });

    document.addEventListener('mouseout', (event) => {
        if (event.target.hasAttribute('size-tooltip')) {
            const disclaimer = event.target.closest('.product-infos-form').querySelector('.disclaimer-select-size');
            if (disclaimer) {
                disclaimer.classList.remove('displayed');
            }
        }
    });

    // SW-19561 - handle #search=??? in home module
    document.querySelectorAll('.homepage a[href*="#search="]').forEach(link => {
        link.addEventListener("click", function (e) {
            e.preventDefault();

            // Gets the href attribute
            const href = link.getAttribute("href");

            // Extracts the search value from the hash
            const match = href.match(/#search=([^&]+)/);

            if (match && match[1]) {
                const searchValue = match[1]; // ex : "sergent%20major"

                // Starts a search with the extracted value
                if (!window.wShop) {
                    console.error("wShop is not defined.");
                    return;
                }

                window.wShop.searchStr = searchValue;
                // Add also the search value in the search input if exists
                try {
                    $("#search_home").val(decodeURIComponent(searchValue));
                    applySearchClass();
                } catch (e) {
                    console.error("Error setting search input value:", e);
                }
                window.wShop.getProducts();
                document.addEventListener("search_getProducts_end", function () {
                    applySearchClass();
                }, { once: true });
            }
        });
    });
});

function initFpVisualsZoom() {
    let thumbs = new Swiper(".product-thumbs-zoom", {
        slidesPerView: 'auto',
        spaceBetween: 10,
        roundLengths: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slideToClickedSlide: true,
    });

    let visual = new Swiper(".product-visual-zoom", {
        lazy: true,
        roundLengths: true,
        thumbs: {
            swiper: thumbs,
        },
    });

    visual.on('slideChange', () => {
        const i = visual.realIndex;
        thumbs.slideTo(i);
    });

    // Sync the zoom thumbs slider to the current index of the main product visual slider
    const mainVisual = document.querySelector('.product-visual');
    if (mainVisual && visual && typeof visual.slideTo === 'function') {
        // Get the current active index from the main product visual slider
        const mainSwiper = mainVisual.swiper;
        if (mainSwiper) {
            thumbs.slideTo(mainSwiper.clickedIndex);
            visual.slideTo(mainSwiper.clickedIndex);
        }
    }
}

function displaySizeModifier(btn) {
    const target = btn.closest('.cart-product-item');

    if (target.hasAttribute('size-selector')) {
        target.removeAttribute('size-selector');
    } else {
        target.setAttribute('size-selector', '');
    }
}

function initCartWishlist() {
    new Swiper('.cart-wishlist-content', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
            prevEl: '.cartWishPrev',
            nextEl: '.cartWishNext',
        },
    });
}

if (document.querySelector('.cart-wishlist-content') && !document.querySelector('.cart-wishlist-empty')) {
    initCartWishlist();
}

window.addEventListener('refreshCart_complete', function() {
    initCartWishlist();
});

window.addEventListener('basketToWish_success', function() {
    initCartWishlist();
});

window.addEventListener('wishToBasket_success', function() {
    initCartWishlist();
});

function panierSwiper() {
    const swiperContainer = document.querySelector('#buyTogetherSlider');

    new Swiper(swiperContainer, {
        slidesPerView: 4,
        spaceBetween: 12,
        navigation: {
            nextEl: '.buyTogetherNext',
            prevEl: '.buyTogetherPrev',
        }
    });
}

if (document.querySelector('#buyTogetherSlider')) {
    panierSwiper();
}

function applySearchClass() {
    let searchInputValue = $("#search_home").val();

    if (searchInputValue.length >= 3) {
        $('body').addClass('search_in');
    } else {
        $('body').removeClass('search_in');
    }
}
